exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#botton-send-server[data-v-a091f2c4]{text-align:right}#bottom-menu[data-v-a091f2c4]{position:fixed;bottom:0;width:100%;background:#fff;padding:10px;box-shadow:0 6px 30px rgba(0,0,0,.1);border-radius:3px;z-index:10}.fa-files-o[data-v-a091f2c4]{cursor:pointer}.send-btn[data-v-a091f2c4]{margin-left:15px;color:#17a2b8!important;padding:5px 20px;text-decoration:none;cursor:pointer;border:1px solid #17a2b8;border-radius:8px;height:2.3em;width:200px;outline:none;overflow:hidden;color:#17a2b8;text-align:center;line-height:222%}.send-btn[data-v-a091f2c4]:hover{color:#fff!important;background:#17a2b8}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a091f2c4","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/app_modules/BottomMenu.vue
// module id = 178
// module chunks = 0